import React from 'react';
import '../styles/wordpress.css';

const CheckIcon = () => (
  <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 001.414 0l8-8a1 1 000-1.414z" clipRule="evenodd" />
  </svg>
);

const plans = [
  {
    name: "WordPress WP1",
    discount: "Up to 67% off 1st mo.",
    price: "$1.99",
    subtitle: "VPS | Ubuntu 24.04 | OpenLiteSpeed. Perfect for personal blogs & small websites.",
    features: [
      "VPS | Ubuntu 24.04",
      "32+ Regions",
      "300x Faster WordPress",
      "OpenLiteSpeed + LSCache",
      "1 vCPU",
      "512MB RAM",
      "10GB NVMe SSD",
      "1TB Bandwidth",
      "IPv4 + IPv6",
      "Daily Backups",
      "Free SSL Certificate",
      "PHP 8.3",
      "MariaDB",
      "WordPress Toolkit",
      "24/7 Tech Support",
    ],
  },
  {
    name: "WordPress WP2",
    discount: "Up to 50% off 1st mo.",
    price: "$4.98",
    subtitle: "VPS | Ubuntu 24.04 | OpenLiteSpeed. For professionals & growing businesses.",
    features: [
      "VPS | Ubuntu 24.04",
      "32+ Regions",
      "300x Faster WordPress",
      "OpenLiteSpeed + LSCache",
      "1 vCPU",
      "1GB RAM",
      "25GB NVMe SSD",
      "1TB Bandwidth",
      "IPv4 + IPv6",
      "Daily Backups",
      "Free SSL Certificate",
      "PHP 8.3",
      "MariaDB",
      "WordPress Toolkit",
      "24/7 Tech Support",
    ],
  },
  {
    name: "WordPress WP3",
    discount: "Up to 50% off 1st mo",
    price: "$7.98",
    subtitle: "VPS | Ubuntu 24.04 | OpenLiteSpeed. Ecommerce & large WordPress sites.",
    features: [
      "VPS | Ubuntu 24.04",
      "32+ Regions",
      "300x Faster WordPress",
      "OpenLiteSpeed + LSCache",
      "1 vCPU",
      "2GB RAM",
      "55GB NVMe SSD",
      "2TB Bandwidth",
      "IPv4 + IPv6",
      "Daily Backups",
      "Free SSL Certificate",
      "PHP 8.3",
      "MariaDB",
      "WordPress Toolkit",
      "24/7 Tech Support",
    ],
  },
  {
    name: "WordPress WPX",
    discount: "Up to 50% off 1st mo",
    price: "$11.99",
    subtitle: "VPS | Ubuntu 24.04 | OpenLiteSpeed. Agencies, developers and enterprises",
    features: [
      "VPS | Ubuntu 24.04",
      "32+ Regions",
      "300x Faster WordPress",
      "OpenLiteSpeed + LSCache",
      "2 vCPU",
      "2GB RAM",
      "65GB NVMe SSD",
      "3TB Bandwidth",
      "IPv4 + IPv6",
      "Daily Backups",
      "Free SSL Certificate",
      "PHP 8.3",
      "MariaDB",
      "WordPress Toolkit",
      "24/7 Tech Support",
    ],
  },
];

function Wordpress() {
  return (
    <div className="pricing-section">
      <div className="pricing-wrapper">
        {plans.map((plan, index) => (
          <div className="pricing-card" key={index}>
            <div className="discount-badge">{plan.discount}</div>
            <h2>{plan.name}</h2>
            <p className="plan-subtitle">{plan.subtitle}</p>
            <p className="plan-price">
              <span className="price-label">Starting from</span><br />
              <span className="price-amount">{plan.price}<span className="per-month">/1st mo</span></span>
            </p>
            <a href="https://account.i-word.net/order/config/preconfig/vps_wordpress" className="start-btn" target="_blank" rel="noopener noreferrer">START NOW</a>
            <div className="divider"></div>
            <ul className="feature-list">
              {plan.features.map((feature, i) => (
                <li key={i}><CheckIcon /> {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Wordpress;

